import vm from '../main'

const internals = {}


internals.addReport = function(reportgeneration) {
    reportgeneration = (({ reportType, downloadType, startDate, endDate, gaManager, station, region, generatedBy, vehicleId ,allVehicle}) => {
        return { reportType, downloadType, startDate, endDate, gaManager, station, region, generatedBy, vehicleId ,allVehicle }
    })(reportgeneration)

    return vm.$reportgenerationDataRepository
        .create(reportgeneration)
        .then(result => {
            reportgeneration = result.data
            return reportgeneration;
        })
        .catch(error => {
            console.error('reportgenerationService.createRegion-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/reportgeneration.service.js